<template>
  <svg 
    :width="`calc(16 / 11 * ${size})`" 
    :height="size" 
    viewBox="0 0 16 11" 
    fill="none"
    class="shevron"
    v-on="$listeners"
  >
    <path d="M14.6372 1.71602L8.14551 9.36649L1.65386 1.71602" :stroke="color" stroke-width="2.28639" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>


<script>
export default {
  name: 'IconShevron',

  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: String,
      default: '1em',
    },
  },
};
</script>